<div class="alert-toaster-container">
    <div *ngFor="let alert of alerts" 
         class="alert alert-{{ alert.type }} alert-dismissible fade show d-flex align-items-center" 
         role="alert">
        <span class="material-symbols-outlined me-2">{{ getIcon(alert.type) }}</span>
        <div class="alert-content">
            <strong *ngIf="alert.title" class="alert-title">{{ alert.title }}</strong>
            <span class="alert-message">{{ alert.message }}</span>
        </div>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismiss(alert.id)"></button>
    </div>
</div>
